




import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'JdFinanceSignSuccess'
})

export default class JdFinanceSignSuccess extends Vue {
  $refs!: {
    toMp: HTMLElement;
  };

  mounted() {
    this.toMp();
  }

  toMp() {
    const type = {
      appId: 'D913B60EE3B761094A1062224A560D82',
      vapptype: process.env.VUE_APP_DATA_ENV === 'production' ? '1' : '2', // 1-线上版，2-体验版
      path: 'package-order/pages/order-list/order-list.html',
      des: 'vapp',
      category: 'jump'
    };

    const url = `openjdjrapp://com.jd.jrapp/jdminiprogram/open?jrparam=${JSON.stringify({ 'type': type })}&jrlogin=true&jrcontainer=native`;

    console.log('url', url);

    window.location.href = url;
  }
}

